module.exports = "/_next/static/images/2daa0083139a7650a84934314efa9ea9-dress-code-1.png";